
import { Week } from '../models/week';
import { TimecardRow } from '../models/timecardrow';

export class ApiTimecard {
    email: string = '';
    weekNo: string = '';
    taskDays: Array<ApiTimecardDay> = [];
    status: string = '';
    empComment: string  = '';
    timeCardId: number = -1;
    message: string = '';

    constructor(apiTimecard?: any) {
        if (!!apiTimecard) {
            this.email = apiTimecard['email'];
            this.weekNo = apiTimecard['weekNo'];
            this.taskDays = ApiTimecardDay.fromJSONArray(apiTimecard['taskDays']);
            this.status = apiTimecard['status'].toLowerCase();
            this.timeCardId = apiTimecard['timeCardId'];
            this.empComment = apiTimecard['empComment'];
            this.message = apiTimecard['message'];
        }
    }
}

export class ApiTimecardDay {
    taskNo: string = '';
    taskName: string = '';
    projNo: string = '';
    projName: string = '';
    expType: string = '';
    timeId: number = 0;
    day?: Date;
    hours: number = 0;
    startDt: Date | undefined;
    endDt: Date | undefined;
    rowOrder: number = 0;
    message: string = '';

    static fromJSONArray(apiTimecardDay: any): Array<ApiTimecardDay> {
        return apiTimecardDay.map((x:any) => new ApiTimecardDay(x));
    }

    constructor(task?: any) {
        if (!!task) {
            this.taskNo = task['taskNo'];
            this.taskName = task['taskName'];
            this.projNo = task['projNo'];
            this.projName = task['projName'];
            this.expType = task['expType'];
            this.timeId = task['timeId'];
            this.day = task['day'];
            this.hours = task['hours'];
            this.startDt = task['startDt'];
            this.endDt = task['endDt'];
            this.message = task['message'];

        }
    }
}

